import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';

@Injectable()
export class TokenService {
    private static tokenKey = 'auth_token';
    private static refreshTokenKey = "refresh_token";
    private static tokenExpirationDateKey = "_auth_token_expiration";
    constructor(private storageService: StorageService) { }

    public setBearerToken(token: string) {
        if (token === null || token === '') {
            this.storageService.remove(TokenService.tokenKey);
        }
        else {
            this.storageService.set(TokenService.tokenKey, token);
        }
    }

    public setRefreshToken(refreshToken: string) {
        if (refreshToken === null || refreshToken === '') {
            this.storageService.remove(TokenService.refreshTokenKey);
        }
        else {
            this.storageService.set(TokenService.refreshTokenKey, refreshToken);
        }
    }

    public setBearerTokenExpiration(bearerTokenExpiration: Date) {
        if (bearerTokenExpiration === null) {
            this.storageService.remove(TokenService.tokenExpirationDateKey);
        }
        else {
            this.storageService.set(TokenService.tokenExpirationDateKey, bearerTokenExpiration);
        }
    }

    public getBearerToken(): string {
        return this.storageService.get<string>(TokenService.tokenKey);
    }

    public getRefreshToken(): string {
        return this.storageService.get<string>(TokenService.refreshTokenKey);
    }

    public isBearerTokenExpired(): boolean {
        let date = this.storageService.get<Date>(TokenService.tokenExpirationDateKey);
        if (date === null)
            return true;
        let currentDate = new Date();
        let convertedDate = new Date(date);
        if (currentDate < convertedDate)
            return false;
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/token.service.ts